import { useEffect } from "react";
import "../style/SearchWidget.css";

const SearchWidget = () => {
  useEffect(() => {
    // Step 1.1: Inject config
    window["myg-widget-config"] = {
      tenantId: "5aef085d-47a2-4a4d-8174-202e314c1f1e", // <-- replace this
      showSendButton: true,
      allowCustomQuery: false,

      // UI Styling
      borderColor: "#529077",
      sendButtonColor: "#529077",
      borderRadius: "20px",
      containerBackground: "#ffffff",
      buttonBackground: "#ffffff",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",

      // Input Field Styling
      placeholderText: "Battery Questions? Ask Here..",
      inputPadding: "16px 16px 16px 0",
      inputFontSize: "16px",
      inputTextColor: "#202124",

      // Icon Size
      sendIconSize: "24px",

      showTopicSuggestions: false,
      topicSuggestionMinWidth: "320px",
      topicBackground: "#ffffff",
      topicTextColor: "#4b8fe2",
      topicBorderColor: "#e1e5e9",
      topicPadding: "8px 16px",
      topicBorderRadius: "24px",
      topicFontSize: "14px",
      topicFontWeight: "500",
    };

    // Step 1.2: Inject script
    // const scriptSrc =
    //   "https://cdn.gooru.org/myg-learn-widget/v1.0.1/learn-box.js";
    const scriptSrc =
      "https://cdn.gooru.org/myg-learn-widget/v1.0.1/learn-box.js";

    const alreadyLoaded = document.querySelector(`script[src="${scriptSrc}"]`);

    if (!alreadyLoaded) {
      const script = document.createElement("script");
      script.src = scriptSrc;
      script.async = true;

      script.onload = () => {
        console.log("✅ Gooru widget loaded");
      };

      script.onerror = () => {
        console.error("❌ Failed to load Gooru widget");
      };

      document.body.appendChild(script);
    } else {
      console.log("ℹ️ Gooru widget script already loaded");
    }

    // Clean up
    return () => {
      delete window["myg-widget-config"];
    };
  }, []);

  return (
    <div id="gooru-widget-wrapper" className="desktop-search-widget">
      <myg-learn-widget />
    </div>
  );
};

export default SearchWidget;
